module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "size": "large",
      "title": "删除 TODO 吗?"
    },
    model: {
      value: (_vm.deleteDialogVisible),
      callback: function($$v) {
        _vm.deleteDialogVisible = $$v
      },
      expression: "deleteDialogVisible"
    }
  }, [_c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteDialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.remove(_vm.removeIndex)
      }
    }
  }, [_vm._v("确认")])], 1)]), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 22,
      "sm": 18,
      "md": 16,
      "lg": 12
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [_c('el-input', {
    attrs: {
      "id": "input",
      "placeholder": "新建一个TODO",
      "icon": "plus",
      "on-icon-click": _vm.add
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.add($event)
      }
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 22,
      "sm": 18,
      "md": 16,
      "lg": 12
    }
  }, [(_vm.items.length === 0) ? _c('el-row', {
    staticClass: "instruction"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [_c('div', [_c('h2', [_vm._v("Jack's  "), _c('span', {
    staticStyle: {
      "color": "#20A0FF"
    }
  }, [_vm._v("Todolist")]), _vm._v(" 项目。")]), _vm._v(" "), _c('p', [_vm._v("填写你的Todo开始行动吧")])])])], 1) : _vm._l((_vm.items), function(item, index) {
    return _c('el-card', {
      staticClass: "todo--card",
      class: item.classes
    }, [_c('el-row', {
      attrs: {
        "type": "flex"
      }
    }, [_c('el-col', {
      staticClass: "todo todo--check"
    }, [_c('i', {
      staticClass: "el-icon-check",
      on: {
        "click": function($event) {
          _vm.complete(index)
        }
      }
    })]), _vm._v(" "), _c('el-col', {
      staticClass: "todo todo--item",
      nativeOn: {
        "click": function($event) {
          !_vm.items[index].edit ? _vm.edit(index) : null
        }
      }
    }, [(!_vm.items[index].edit) ? _c('p', [_vm._v(_vm._s(item.text))]) : _c('el-input', {
      nativeOn: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.edit(index)
        }
      },
      model: {
        value: (_vm.items[index].text),
        callback: function($$v) {
          _vm.items[index].text = (typeof $$v === 'string' ? $$v.trim() : $$v)
        },
        expression: "items[index].text"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "todo todo--icon",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('i', {
      staticClass: "el-icon-edit",
      on: {
        "click": function($event) {
          _vm.edit(index)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          (_vm.deleteDialogVisible = true, _vm.removeIndex = index)
        }
      }
    })])], 1)], 1)
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "2em"
    }
  }, [_c('el-col', [_c('transition', {
    attrs: {
      "name": "fade-delay"
    }
  }, [(_vm.clearVisible) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("全部删除")]) : _vm._e()], 1)], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-089b616f"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 65
// module chunks = 0